import { showNotification } from "@mantine/notifications";
import { MedplumClient } from "@medplum/core";

const educationBotHandler = async (medplum: MedplumClient, payload: any) => {
    try {
        const res = await medplum.executeBot(
            {
                system: "https://api-stage.healthconnect.systems/bots",
                value: "patient-education-service",
            },
            payload
        );
        if (res.statusCode > 300)
            showNotification({
                color: "red",
                message: `Something went wrong: ${res.body}`,
                autoClose: true,
            });
            
        return res.body;
    } catch (err) {
        showNotification({
            color: "red",
            message: `Something went wrong: ${err}`,
            autoClose: true,
        });
        console.error("Unexpected error:", err);
    }
}

const startEducationChat = async (medplum: MedplumClient, patientId: any) => {
    const res = await educationBotHandler(medplum, {
        eventType: 'start-chat',
        patientId: patientId
    });
    return res;
}


const getEducationChat = async (medplum: MedplumClient, qnrResId: string, message: string, agentName: string) => {
    const res = await educationBotHandler(medplum, {
        eventType: 'process-response',
        qnrResId: qnrResId,
        message: message,
        agentName: agentName
    });
    return res;
}

const startEducationCall = async (medplum: MedplumClient, patientId: any, phoneNumber: string) => {
    const res = await educationBotHandler(medplum, {
        eventType: 'init-call',
        patientId: patientId,
        phoneNumber: phoneNumber
    });
    return res;
}

export { startEducationChat, getEducationChat, startEducationCall }